// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nKOmRfGtY_ {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.nKOmRfGtY_ h4 {
  line-height: 3em;
}
.nKOmRfGtY_ .AKYQjUKleC {
  float: left;
  width: 100%;
}
.nKOmRfGtY_ .IY_tw9qu_v {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.nKOmRfGtY_ .IY_tw9qu_v:hover {
  cursor: pointer;
}
.nKOmRfGtY_ .IY_tw9qu_v:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.qzLE5jIRpA .WhPi3SPqKy:focus {
  outline: none;
}
.qzLE5jIRpA .WhPi3SPqKy.SvHYRfHSc_.MXYUkE7Utj {
  background: #375A88;
}
.qzLE5jIRpA .WhPi3SPqKy.SvHYRfHSc_.MXYUkE7Utj span {
  color: #fff;
}
.qzLE5jIRpA .MXYUkE7Utj {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.qzLE5jIRpA .MXYUkE7Utj:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.qzLE5jIRpA input {
  height: 38px;
  min-width: 220px;
}
.IY_tw9qu_v.QuWV37VI4x {
  background: #410102;
}
.IY_tw9qu_v.fObBNvd6fc {
  background: #911318;
}
.IY_tw9qu_v.Vp5BvUTUq4 {
  background: #D8293B;
}
.IY_tw9qu_v.C8YRvJH1zH {
  background: #F2373C;
}
.IY_tw9qu_v.Utu7dL8_uP {
  background: #FC4448;
}
.IY_tw9qu_v.gGLFPrZ65o {
  background: #ED535E;
}
.IY_tw9qu_v.T3KkHSsuPg {
  background: #E34926;
}
.IY_tw9qu_v.AOImPnsDPP {
  background: #FC562B;
}
.IY_tw9qu_v.O28J_xagfE {
  background: #FC6722;
}
.IY_tw9qu_v.w9yqZnzf2j {
  background: #FD7F24;
}
.IY_tw9qu_v.ktPJgcujQy {
  background: #FD8D26;
}
.IY_tw9qu_v.mOooMzVZ0G {
  background: #EC9C3E;
}
.IY_tw9qu_v.ShiB_HQzQ9 {
  background: #0e673a;
}
.IY_tw9qu_v.VSHgPk7pYr {
  background: #208740;
}
.IY_tw9qu_v.mdslN8GtK1 {
  background: #239718;
}
.IY_tw9qu_v.eUIqP2m3Z7 {
  background: #55A84D;
}
.IY_tw9qu_v.ymo3_lxvjj {
  background: #4BBE5A;
}
.IY_tw9qu_v.eWHVhZG_rs {
  background: #0CCA6A;
}
.IY_tw9qu_v.G7BnXYbqGg {
  background: #0A3C64;
}
.IY_tw9qu_v.W5cuCJDeSX {
  background: #0d487a;
}
.IY_tw9qu_v.W4fcGR9pk3 {
  background: #10538d;
}
.IY_tw9qu_v.iOddt4Ms__ {
  background: #115A99;
}
.IY_tw9qu_v.VS64Wz7lqV {
  background: #3387E2;
}
.IY_tw9qu_v.FSM_tLflSc {
  background: #1BA9CF;
}
.IY_tw9qu_v.jR2_zaFGhB {
  background: #d27c02;
}
.IY_tw9qu_v.gA7FpXxeBq {
  background: #fb9402;
}
.IY_tw9qu_v.NtB4Riu6Iq {
  background: #FD9B30;
}
.IY_tw9qu_v.biFJxfMSai {
  background: #FDBE2D;
}
.IY_tw9qu_v.aMWXCBkkD3 {
  background: #FED831;
}
.IY_tw9qu_v.smWvPSXWbM {
  background: #FFFD38;
}
.IY_tw9qu_v.hovo7FNBTA {
  background: #2D215C;
}
.IY_tw9qu_v.zrSa0GVjt_ {
  background: #483C83;
}
.IY_tw9qu_v.pLR7Duzgnt {
  background: #58518d;
}
.IY_tw9qu_v.jKyPUwHgNF {
  background: #7068A9;
}
.IY_tw9qu_v.WGLgUgiUJx {
  background: #7f78b2;
}
.IY_tw9qu_v.XAApaKq86Q {
  background: #8f88bc;
}
.IY_tw9qu_v.fk_Neeu4Rp {
  background: #000;
}
.IY_tw9qu_v.qn2iulIeqP {
  background: #282626;
}
.IY_tw9qu_v.axjD5W13dN {
  background: #242222;
}
.IY_tw9qu_v.FeEeQuA7d4 {
  background: #353838;
}
.IY_tw9qu_v.wxQQed_NhZ {
  background: #666;
}
.IY_tw9qu_v.zy4wD1XN_5 {
  background: #999;
}
.a32Jm0b9fx {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.a32Jm0b9fx .f8B4XnIL2O {
  display: none;
}
.ImgUfz40Ag {
  display: flex;
  flex-direction: column;
  margin: 22px 80px 42px;
}
.ImgUfz40Ag .GUiG2Zc8YK {
  display: flex;
  align-items: center;
  margin-top: 12px;
}
.ImgUfz40Ag .GUiG2Zc8YK .O3Ik8f04Wy {
  width: 336px;
  height: 136px;
  margin-right: 20px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
}
.ImgUfz40Ag .GUiG2Zc8YK .O3Ik8f04Wy .BAs2BMJc_g {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  padding: 24px;
}
.ImgUfz40Ag .GUiG2Zc8YK .O3Ik8f04Wy .BAs2BMJc_g .SPVTDbw649 {
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  letter-spacing: normal;
  line-height: 19px;
}
.ImgUfz40Ag .GUiG2Zc8YK .O3Ik8f04Wy .BAs2BMJc_g .Jhmvr3wvmk {
  font-size: 48px;
}
.ImgUfz40Ag .GUiG2Zc8YK .O3Ik8f04Wy:hover,
.ImgUfz40Ag .GUiG2Zc8YK .O4v8kx_5Eh {
  color: #F5F6FA;
  background-color: #0288a1;
}
.ImgUfz40Ag .GUiG2Zc8YK .O3Ik8f04Wy:hover .SPVTDbw649,
.ImgUfz40Ag .GUiG2Zc8YK .O4v8kx_5Eh .SPVTDbw649 {
  color: #F5F6FA;
}
.ImgUfz40Ag .GUiG2Zc8YK .O3Ik8f04Wy:last-child {
  margin-right: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `nKOmRfGtY_`,
	"color-row": `AKYQjUKleC`,
	"color-tile": `IY_tw9qu_v`,
	"picker-component": `qzLE5jIRpA`,
	"picker-element": `WhPi3SPqKy`,
	"active": `SvHYRfHSc_`,
	"btn": `MXYUkE7Utj`,
	"red-1": `QuWV37VI4x`,
	"red-2": `fObBNvd6fc`,
	"red-3": `Vp5BvUTUq4`,
	"red-4": `C8YRvJH1zH`,
	"red-5": `Utu7dL8_uP`,
	"red-6": `gGLFPrZ65o`,
	"orange-1": `T3KkHSsuPg`,
	"orange-2": `AOImPnsDPP`,
	"orange-3": `O28J_xagfE`,
	"orange-4": `w9yqZnzf2j`,
	"orange-5": `ktPJgcujQy`,
	"orange-6": `mOooMzVZ0G`,
	"green-1": `ShiB_HQzQ9`,
	"green-2": `VSHgPk7pYr`,
	"green-3": `mdslN8GtK1`,
	"green-4": `eUIqP2m3Z7`,
	"green-5": `ymo3_lxvjj`,
	"green-6": `eWHVhZG_rs`,
	"blue-1": `G7BnXYbqGg`,
	"blue-2": `W5cuCJDeSX`,
	"blue-3": `W4fcGR9pk3`,
	"blue-4": `iOddt4Ms__`,
	"blue-5": `VS64Wz7lqV`,
	"blue-6": `FSM_tLflSc`,
	"yellow-1": `jR2_zaFGhB`,
	"yellow-2": `gA7FpXxeBq`,
	"yellow-3": `NtB4Riu6Iq`,
	"yellow-4": `biFJxfMSai`,
	"yellow-5": `aMWXCBkkD3`,
	"yellow-6": `smWvPSXWbM`,
	"purple-1": `hovo7FNBTA`,
	"purple-2": `zrSa0GVjt_`,
	"purple-3": `pLR7Duzgnt`,
	"purple-4": `jKyPUwHgNF`,
	"purple-5": `WGLgUgiUJx`,
	"purple-6": `XAApaKq86Q`,
	"black-1": `fk_Neeu4Rp`,
	"black-2": `qn2iulIeqP`,
	"black-3": `axjD5W13dN`,
	"black-4": `FeEeQuA7d4`,
	"black-5": `wxQQed_NhZ`,
	"black-6": `zy4wD1XN_5`,
	"picker-theme": `a32Jm0b9fx`,
	"arrow-regular": `f8B4XnIL2O`,
	"modal-option__root": `ImgUfz40Ag`,
	"modal-option__list": `GUiG2Zc8YK`,
	"modal-option__item": `O3Ik8f04Wy`,
	"option-item__content": `BAs2BMJc_g`,
	"option-item__label": `SPVTDbw649`,
	"option-item__icon": `Jhmvr3wvmk`,
	"modal-option__item--selected": `O4v8kx_5Eh`
};
export default ___CSS_LOADER_EXPORT___;
